<template>
<main class="row onboarding-wrapper">
    <div class="col-md-12 ob-rightcol">
        <template v-if="!agentFullName">
            <div class="primary-heading" >
                First, enter your NRDS number
            </div>
            <div class="secondary-heading mt-1">
                You know that number you thought you’d never be able to memorize...
            </div>
            <div class="state-agent">
                <div class="sa-frm-row mt-4 mb-1" >
                    <div class="sa-form-control">
                        <input class="sa-control" type="text" placeholder="9 digit NRDS number" @keyup="resetError" v-model = "agentKey"/>
                    </div>
                    <div v-if="errorText == 'enterKey'" class="sa-label error-text" style="text-align:left;">Please enter NRDS number</div>
                    <div v-if="errorText == 'wrongFormat'" class="sa-label error-text" style="text-align:left;">NRDS should be a 9 digit number.</div>
                    <div v-if="errorText == 'wrongInfo'" class="sa-label error-text" style="text-align:left;"> Sorry, we could not found any information for this NRDS number. Please enter a valid one.</div>
                </div>
                <div class="sa-frm-row mb-0">
                    <div class="ob-btn-wrapper" style="border-top:none;float:right;">
                        <button  v-if="!loadingAgentData" class="ob-button" style = "align-items:center" @click = "getAgentDetails">Get Started</button>
                        <div  v-if="loadingAgentData" class="rotate-btn-wrap" style = "align-items:center">
                            <div class="loader"></div>
                        </div>
                    </div>
                </div>
                <div class="sa-frm-row mt-3">
                    <!-- <div class="sa-form-control" style="float:left;width:100%;">
                        <input type="checkbox" id="privacyTerms" v-model="allowMail" @click="resetError" class="sa-checkbox" name="privacyPolicy" />
                        <div class="sa-label agree-txt-label">
                            <span class="lbl">It’s okay to send me emails about PrintedAgent.com</span>
                        </div>
                    </div> -->
                    <div class="sa-form-control" style="float:left;width:100%;">
                        <input type="checkbox" id="privacyTerms" v-model="termsOfService" @click="resetError" class="sa-checkbox" name="privacyPolicy" />
                        <div class="sa-label agree-txt-label">
                            <span class="lbl">I accept the <a id="termsOfService" class="cursor-pointer" @click=" showTermsPopup  = true" style="color: rgb(25, 156, 198);text-decoration: underline;">Terms of Service</a>
                            and <a id="privacyPolicy" class="cursor-pointer" @click=" showPrivacyPopup = true" style="color: rgb(25, 156, 198);text-decoration: underline;">Privacy Policy</a>.</span>
                        </div>
                    </div>
                    <div v-if="errorText == 'checkTerms'" class="sa-label error-text" style="text-align:left;">Before using {{orgTitle}}, you must read and agree to our terms of service and privacy policy.</div>
                </div>
            </div>
            <div class="mt-4 region-info-text" >
                {{orgTitle}} is currently available in MN, IA, WI, SD & ND
                Request your market here.
            </div>
            <div class="mt-4 region-info-text" >
                Click here to register as <router-link to="/registerTeam">Team</router-link>
            </div>
        </template>
        <template v-if="(agentFullName && !inviteStatus) || (agentFullName && (inviteStatus == 'INVITED'))">
            <div class="primary-heading text-capitalize" >
                Welcome, {{agentFullName}}!
            </div>
            <div class="email-img-wrap mt-4">
                <img src="@/assets/images/newui/email_plcaholder_4x.png" alt="">
            </div>
            <div class="secondary-heading mt-4 w600" >
                We just sent an email to you at {{agentEmail}} <br> Simply click the link in the email to verify your account and then we can get started.
            </div>
            <div class="mt-4 region-info-text" >
                Didn't get an email? Try your NRDS again, check your spam folder, or <a href="#" @click="openMailPopup">contact support</a>
            </div>
        </template>
        <template v-if="agentFullName && (inviteStatus == 'ACCEPTED')">
            <ExistingUser :userName="agentFullName"></ExistingUser>
        </template>
        <PrivacyPolicy v-if="showPrivacyPopup" @closePopup="closePopup"/>
        <WorbixTermsPopup v-if="showTermsPopup" @closePopup="closePopup"/>
        <AdminEmail v-if="mailPopup" :agent="mailData" @closePopup="closePopup"/>
        <ConfirmBrokerage v-if="existsInOtherSpace" :office="office" @closePopup="closeBrokeragePopup" @moveBrokerage="fetchAgentData(true)"/>
        <div id="panelBackdrop" v-if="showPrivacyPopup || showTermsPopup || mailPopup || existsInOtherSpace"></div>
    </div>
</main>
</template>

<script>
// @ is an alias to /src
import AgentLogo from '@/components/agent-logo.vue'
import FooterLeft from '@/components/footer-left.vue'
import ExistingUser from '@/components/ExistingUser.vue'
import ConfirmBrokerage from '@/components/ConfirmBrokerage.vue'
import Multiselect from 'vue-multiselect'
import PrivacyPolicy from '@/components/PrivacyPolicy.vue'
import AdminEmail from '@/components/AdminEmail.vue'
import WorbixTermsPopup from '@/components/WorbixTermsPopup.vue'
import {appEnv, worbixServerUrl, invitationLink, demoNRDS, fakeBrokerageEmail} from '@/properties'
import { mapActions } from "vuex";
export default {
    name: 'State',
    components: {
        AgentLogo,
        ConfirmBrokerage,
        FooterLeft,
		Multiselect,
        WorbixTermsPopup,
        ExistingUser,
        PrivacyPolicy,
        AdminEmail
    },
    data(){
        return{
            selectedOffice:{},
            officeList	:[],
            agentKey:"",
            allowMail:false,
            termsOfService:false,
            errorText:'',
            switchToNewOffice :false,
            existsInOtherSpace:false,
            agentInfo:null,
            office:{},
            mailData:null,
            agentFullName : '',
            agentEmail :'',
            loginLink:null,
            routeParams:null,
            inviteStatus:null,
            loadingAgentData:false,
            showTermsPopup:false,
            showPrivacyPopup:false,
            mailPopup:false,
        }
    },
	mounted(){
        this.loginLink = worbixServerUrl;
        this.routeParams = this.$route.fullPath.replace('/', '');
        // console.log('routeParams', this.routeParams);
	},
    computed:{
        orgTitle (){
            return this.$store.state.orgTitle
        },
        updateEmail(){
            console.log({appEnv});
            let updateEmail = false;
            if (appEnv != 'prod') {
                updateEmail = true;
            }
            return  updateEmail
        }
    },
	methods:{
        ...mapActions({
            getAgentData: "getAgentData",
        }),
		async getAgentDetails(){
            if (!this.agentKey) {
                this.errorText = 'enterKey'
                return;
            }
            if (this.agentKey && (!this.validateNumber(this.agentKey) || this.agentKey.length != 9)) {
                this.errorText = 'wrongFormat'
                return;
            }
            if (!this.termsOfService) {
                this.errorText = 'checkTerms'
                return;
            }
            if (this.routeParams && this.routeParams == demoNRDS) {
                this.fetchDemoAgentData();
                return;
            }

			let payload = {
				agentKey : this.agentKey,
                updateEmail : this.updateEmail,
                saveAgentToWorbix:false,
                invitationLink:invitationLink
			}
            this.loadingAgentData = true;
            let agentData = await this.getAgentData(payload);
            if (agentData && !Object.keys(agentData).length) {
                this.errorText = 'wrongInfo';
                this.loadingAgentData = false;
                return;
            }
            let officeId = agentData.brokerage.UID;
            payload['officeId'] = officeId;
			let agentWorbixStatus = await this.$store.dispatch("checkIfAgentExists", payload);
            if (agentWorbixStatus.agentDoesNotExist) {
                await this.fetchAgentData(true);
            }else if (agentWorbixStatus && agentWorbixStatus.ExistsInOtherSpace) {
                this.office['old'] = agentWorbixStatus.OtherOfficeName ? agentWorbixStatus.OtherOfficeName[0] : null;
                this.office['new'] = agentData.brokerage ? agentData.brokerage.Name : null;
                this.existsInOtherSpace = true;
            }else {
                let worbixActor = agentWorbixStatus['Actor']
                this.inviteStatus = worbixActor.contact.inviteStatus;
                this.agentInfo = worbixActor;
                if (this.inviteStatus == "INVITED") {
                    await this.$store.dispatch("reInviteAgent", {invitationId:worbixActor.invitations[0].id, invitationLink: invitationLink});
                }
                this.agentFullName = worbixActor.contact.title ? worbixActor.contact.title.split(' ')[0] : '';
                let basicProfile = worbixActor.contact.profiles.find((item)=>{
                    return item.type == 'com.worbix.model.BasicProfile';
                })
                let emails = basicProfile.emails;
                if (emails.length) {
                    this.agentEmail = emails[0].email;
                }
                this.loadingAgentData = false;
            }
		},
        closeBrokeragePopup(){
            this.fetchAgentData(false);
            this.inviteStatus = 'ACCEPTED'
        },
        async fetchAgentData (saveAgentToWorbix){
            this.loadingAgentData = true;
            let payload = {
                agentKey : this.agentKey,
                updateEmail : this.updateEmail,
                saveAgentToWorbix: saveAgentToWorbix,
                invitationLink: invitationLink
            }
            let res = await this.getAgentData(payload);
            if (res && !Object.keys(res).length) {
                this.errorText = 'wrongInfo';
            }else {
                this.agentInfo = res;
                this.agentEmail = this.agentInfo.agent.EMail;
                this.agentFullName = this.agentInfo.agent.FirstName;
            }
            this.loadingAgentData = false;
            this.existsInOtherSpace = false;
        },
        async fetchDemoAgentData(){
            let payload = {}
            payload.emailId = fakeBrokerageEmail
            payload.inviteLink = invitationLink + '#/setupAccount/demo'
            let fakeBrokerageInvite = await this.$store.dispatch("fakeBrokerageInvite", payload);
            this.loadingAgentData = false;
            this.agentEmail = 'johnsmith@maildrop.cc';
            this.agentFullName = 'John';
        },
        resetError(){
            this.errorText = '';
        },
        validateNumber(number){
            const re = /^[0-9]+$/;
            return re.test(number);
        },
        closePopup(){
            this.showPrivacyPopup = false;
            this.showTermsPopup = false;
            this.mailPopup = false;
        },
        openMailPopup(){
            let mailData = {};
            mailData['email'] = this.agentEmail;
            mailData['agentKey'] = this.agentKey;
            mailData['fullName'] = this.agentFullName.charAt(0).toUpperCase() + this.agentFullName.slice(1);
            if (this.agentInfo.contact) {
                let basicProfile = this.agentInfo.contact.profiles.find((item)=>{
                    return item.type == 'com.worbix.model.BasicProfile';
                })
                if (basicProfile && basicProfile.phoneDetails) {
                    let mobilePhone = basicProfile.phoneDetails.find((item)=>{
                        return item.type == 'MOBILE'
                    })
                    mailData['phone'] = (mobilePhone && mobilePhone['numberString']) ? mobilePhone['numberString']  : '';
                }
                if (this.agentInfo.contact.organization && this.agentInfo.contact.organization.displayTitle) {
                    mailData['brokerage']  = this.agentInfo.contact.organization.displayTitle
                }else {
                    mailData['brokerage']  = '-'
                }
            }
            if (this.agentInfo.agent) {
                mailData['phone'] = this.agentInfo.agent.CellPhone ? this.agentInfo.agent.CellPhone : '';
                mailData['brokerage']  = this.agentInfo.brokerage ? this.agentInfo.brokerage.Name : '-'
            }
            mailData['message'] = "I didn't receive the email for account verification."
            this.mailData = mailData;
            this.mailPopup = true;
        },
        async sendAdminMail(){
            let payload = {};

            let fakeBrokerageInvite = await this.$store.dispatch("sentMailToAdmin", payload);
        },
		customLabel(data){
			return Object.keys(data).length ? `${data.Name} (${data.StreetAddress})` : ''
		}
	}
}
</script>

<style>
.error-wrapper{
    text-align: left;
    color: #ffffff;
    background-color: #db082b;
    border-color: #a00620;
    padding: 15px;
    border-radius: 4px;
    width: 500px;
    font-size: 25px;
    position: fixed;
    bottom: 20px;
    right: 20px;
    padding-top: 25px;
}

.error-wrapper .fa{
    position: absolute;
    right: 8px;
    top: 5px;
    cursor: pointer;
}

.multiselect.form-control.multi-dropdown {
	padding: 0;
	height: auto;
}
.multi-select .multiselect.form-control.multi-dropdown {
    border: 1 #e1e1e1 solid;
	height:98px
}

.multi-select .multiselect__tags{
	border:0px;
	font-size:14px;
	font-family:inherit;
	height:98px
}

.multi-select .multiselect__select{
	height:98px
}

.multi-select .multiselect__single{
	font-size:45px;
	color:#666666;
	font-weight:300;
	display: inline-flex;
	align-items: center;
	height:100%;
	overflow:hidden;
	white-space: nowrap;
}

.multi-select .multiselect__input{
	font-size:45px;
	color:#666666;
	font-weight:300;
	height:100%
}

.multi-select .multiselect__element{
	color:#666666;
}

.multi-select .multiselect__option{
    font-size: 1.25rem;
}



</style>
